import { Component, OnInit } from '@angular/core';
import { SignUpUser } from '../../../shared/classes/sign-up-user';
import { UserService } from '../../../shared/services/user.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent implements OnInit {
  user: SignUpUser = <SignUpUser>{};
  registering: boolean;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  fnFocus: boolean = false;
  lnFocus: boolean = false;
  emailFocus: boolean = false;
  phoneFocus: boolean = false;
  pwFocus: boolean = false;
  pwConfirmFocus: boolean = false;
  emailTaken: boolean = false;

  constructor(private UserService: UserService, private router: Router, private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Register');
    if (this.UserService.isLoggedIn()) {
      localStorage.clear()
    }
  }

  register(registerForm: NgForm) {
    this.registering = true;
    if (registerForm.invalid || this.emailTaken) {
      return;
    }
    window.analytics.track("Self-Signup User Pre-Registraion Submitted");
    this.UserService.saveSignUpUser(this.user)
    this.registering = false;
    this.router.navigate(['/onboarding/companyinfo']);

  }

  checkEmailExist() {
    this.UserService.checkEmailExist(this.user.email)
      .subscribe(res => {
        this.emailTaken = res.attempt;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/register-page/register-page.component.ts